import React from "react";

const Alert = ({ message }) => {
  return (
    <div
      className="mb-3 mt-3 border-l-4 border-red-600 bg-red-200 p-4 text-red-600"
      role="alert"
    >
      <p className="text-lg font-medium">Error</p>
      <p>{message}</p>
    </div>
  );
};

export default Alert;
